var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "row",
      class: _vm.zigzag.fragmentClasses,
      attrs: { id: "anchor-zig-zag" },
    },
    _vm._l(_vm.zigzag.zigZagItems, function (zigZag, index) {
      return _c("div", { staticClass: "col-12 p-md-0" }, [
        _c(
          "div",
          {
            class:
              "card ob1-push ob1-push-zigzag ob1-push-shadow-right " +
              (index === _vm.zigzag.zigZagItems.length - 1
                ? _vm.additionalClasses
                : "") +
              " " +
              _vm.definePictureLayout(index),
          },
          [
            _c("div", { staticClass: "card-item" }, [
              zigZag.image
                ? _c(
                    "div",
                    {
                      staticClass: "card-header",
                      class:
                        index === _vm.zigzag.zigZagItems.length - 1
                          ? _vm.additionalClasses
                          : "",
                    },
                    [
                      _c("ob1-picture", {
                        attrs: {
                          cssClasses: "card-img-top",
                          visual: zigZag.image,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              zigZag.video
                ? _c(
                    "div",
                    { staticClass: "card-header video-height" },
                    [_c("video-container", { attrs: { src: zigZag.video } })],
                    1
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-item" },
              _vm._l(zigZag.body, function (item) {
                return _c("div", { staticClass: "card-body" }, [
                  _c(
                    "h3",
                    { staticClass: "card-title", attrs: { "data-clamp": "2" } },
                    [_vm._v(_vm._s(item.title))]
                  ),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "card-text",
                    domProps: { innerHTML: _vm._s(item.textHtml) },
                  }),
                  _vm._v(" "),
                  item.btnLabel !== ""
                    ? _c("p", { staticClass: "py-0 card-btn" }, [
                        _c(
                          "a",
                          {
                            staticClass: "btn btn-secondary",
                            attrs: {
                              href: item.btnLink,
                              "data-oevent-category": item.btnTms.tagZone,
                              "data-oevent-action": item.btnTms.tagName,
                              "data-oevent-label": item.btnTms.tagTarget,
                            },
                          },
                          [_vm._v(_vm._s(item.btnLabel))]
                        ),
                      ])
                    : _vm._e(),
                ])
              }),
              0
            ),
          ]
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }